import { useRef } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";

interface DepositInvoicePromptDialogProps {
  open: boolean;
  depositAmount: string;
  isCreating?: boolean;
  onConfirm: () => void;
  onSkip: () => void;
}

export function DepositInvoicePromptDialog({
  open,
  depositAmount,
  isCreating = false,
  onConfirm,
  onSkip,
}: DepositInvoicePromptDialogProps) {
  const confirmedRef = useRef(false);

  const handleConfirm = () => {
    confirmedRef.current = true;
    onConfirm();
  };

  const handleSkip = () => {
    confirmedRef.current = true;
    onSkip();
  };

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen && !confirmedRef.current) {
      onSkip();
    }
    if (!isOpen) {
      confirmedRef.current = false;
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={handleOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Create a deposit invoice?</AlertDialogTitle>
          <AlertDialogDescription>
            This quote has a deposit of <strong>{depositAmount}</strong> configured. Would you like to convert it to an invoice and create a deposit invoice now?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleSkip} disabled={isCreating}>
            Skip
          </AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm} disabled={isCreating}>
            {isCreating && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Create Deposit Invoice
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
